import { render, staticRenderFns } from "./ProfileVerification.vue?vue&type=template&id=604da1f2"
import script from "./ProfileVerification.vue?vue&type=script&lang=js"
export * from "./ProfileVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports